import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

export default function ChangePassword() {
  const [newPassword, setNewPassword]     = useState('');
  const [confirmPassword, setConfirm]     = useState('');
  const [error, setError]                 = useState('');
  const [loading, setLoading]             = useState(false);
  const navigate = useNavigate();

  const currentUser = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
  })();
  const uid = currentUser._id || currentUser.id;

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await api.put(`/auth/users/${uid}/password`, { newPassword });
      // Update local user so mustChangePassword is cleared
      const updated = { ...currentUser, mustChangePassword: false };
      localStorage.setItem('user', JSON.stringify(updated));
      navigate('/home');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem',
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Logo */}
        <div className="text-center mb-4">
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 52, height: 52, borderRadius: 13,
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            fontSize: 26, fontWeight: 900, color: '#fff', marginBottom: 12,
            boxShadow: '0 8px 24px rgba(99,102,241,.4)',
          }}>Z</div>
          <h2 style={{ color: '#fff', fontWeight: 800, margin: 0 }}>Set Your Password</h2>
          <p style={{ color: '#94a3b8', marginTop: 4, fontSize: 14 }}>
            Hi <strong style={{ color: '#e2e8f0' }}>{currentUser.username}</strong> — your admin set a temporary password.<br />
            Please choose a new one to continue.
          </p>
        </div>

        <div style={{ background: '#fff', borderRadius: 18, padding: '2rem', boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
          {error && (
            <div className="alert alert-danger d-flex align-items-center gap-2 py-2" style={{ fontSize: 14 }}>
              <span>⚠️</span> {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold">New Password</label>
              <input
                type="password"
                className="form-control form-control-lg"
                placeholder="Min. 6 characters"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                required
                autoFocus
                minLength={6}
              />
            </div>
            <div className="mb-4">
              <label className="form-label fw-semibold">Confirm New Password</label>
              <input
                type="password"
                className="form-control form-control-lg"
                placeholder="Repeat password"
                value={confirmPassword}
                onChange={e => setConfirm(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="btn w-100 fw-semibold"
              disabled={loading}
              style={{
                background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                color: '#fff', padding: '12px', fontSize: 15, borderRadius: 10,
              }}
            >
              {loading
                ? <><span className="spinner-border spinner-border-sm me-2" />Saving…</>
                : '🔐 Set Password & Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
